import { ILocalStorage } from './interfaces';

class LocalStorage implements ILocalStorage {
  set(name: string, value: any) {
    localStorage.setItem(name, JSON.stringify(value));
  }

  get(key: string) {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  delete(key: string) {
    localStorage.removeItem(key);
  }

  update(key: string, value: Record<string, any>) {
    const newData = this.get(key) || {};
    for (const k in value) {
      newData[k] = value[k];
    }
    this.set(key, newData);
  }
}

export default LocalStorage;
